import React, { useContext, createContext, useState, useEffect, memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useRef } from "react";
import { serverAddress } from "../config";
import axios from "axios";
import { ThemeProvider } from "@emotion/react";
import {
  Box,
  Button,
  LinearProgress,
  Paper,
  Typography,
  createTheme
} from "@mui/material";

import { baseURL } from "../api";
import { EventSourcePolyfill } from "event-source-polyfill";
import { createFormRequestManager } from "./formRequestManager";
import CustomAlert, {
  retainAlertsForRoute,
  scopeAlertToRoute,
  subscribePersistentAlerts
} from "../component/AlertComponent/Alert";
import {
  clearAuthentication,
  getAccessToken,
  refreshSession
} from "../auth/authClient";

const Contaxt = createContext();

function GlobalData({ children }) {
  const formname = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState(getAccessToken());
  const [userData, setUserData] = useState();
  const [handleClickOpen, setHandleClickOpen] = useState(null);
  const [modalEditData, setModalEditData] = useState({});
  const [openModalData, setOpenModalData] = useState({});
  const [isOpenModalChildData, setIsOpenModalChildData] = useState(false);
  const [openModalChildData, setOpenModalChildData] = useState([]);
  const [openModalDataActive, setopenModalDataActive] = useState({});
  const [modalActionTypeAndID, setModalActionTypeAndID] = useState({});
  const [textValue, setTextValue] = useState({});
  const [fetchDataHandleDataGrid, setFetchDataHandleDataGrid] = useState({});
  const [reportPrintUpdate, setReportPrintUpdate] = useState(null);
  const [editApi, setEditApi] = useState(null);
  const [modalPrimaryKey, setModalPrimaryKry] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [globalFormData, setGlobalFormData] = useState(null);
  const [freeFormInitState, setFreeFormInitState] = useState({});
  const [mainFormData, setmainFormData] = useState([]);
  const [defaultTableSummaryData, setDefaultTableSummaryData] = useState([]);
  const [globalvariables, setglobalvariables] = useState({});
  const [sideBarActive, setsideBarActive] = useState("");
  const [sideBarStyle, setsideBarStyle] = useState("");
  const [isPageLoading, setisPageLoading] = useState(true);
  const [isoverLayDataLoading, setisoverLayDataLoading] = useState(true);
  const [autoCompleteAPICheck, setAutoCompleteAPICheck] = useState([]);
  const [autoCompleteData, setAutoCompleteData] = useState([]);
  const [freeFormToDefault, setFreeFormToDefault] = useState(false);
  const [globalReloadTriggred, setGlobalReloadTriggered] = useState(false);
  const [globalDefaultAutoValueData, setGlobalDefaultAutoValueData] = useState([]);
  const [globalFreeFormAutoValueData, setGlobalFreeFormAutoValueData] = useState([]);
  const [freeFormDataSubmit, setFreeFormDataSubmit] = useState([]);
  const [dataGridOptions, setDataGridOptions] = useState();
  const [freeFromtableRowDataStore, setFreeFromTableRowDataStore] = useState([]);
  const [formData, setFormData] = useState();
  const [isAlertPopup, setIsAlertPopup] = useState(true);
  const [overlaySplit, setOverLaySplit] = useState(false);
  const [overlaySplitOldData, setOverLaySplitOldData] = useState(true);
  const [overLayDataFetchApi, setOverLayDataFetchApi] = useState(null);
  const [defaultTableSummaryFeild, setdefaultTableSummaryFeild] = useState({});
  const [nestedDialog, setNestedDialog] = useState(false);
  const mainRoute = formname.pathname + formname.search;
  const mainRouteRef = useRef(mainRoute);
  const previousMainRouteRef = useRef(mainRoute);
  const overlayRouteRef = useRef("");
  const formRequestManagerRef = useRef();

  mainRouteRef.current = mainRoute;

  if (!formRequestManagerRef.current) {
    formRequestManagerRef.current = createFormRequestManager();
  }

  const [openDocumentSelect, setOpenDocumentSelect] = useState(false);
  const [multiDocumentSelectData, setMultiDocumentSelectData] = useState([]);
  const [multiDocumentSelectDataForTable, setmultiDocumentSelectDataForTable] = useState([]);

  const [isDialogDrawerOpen, setDialogDrawerOpen] = useState(false);
  const isDialogDrawerOpenRef = useRef(isDialogDrawerOpen);
  isDialogDrawerOpenRef.current = isDialogDrawerOpen;
  const [varCustomDialogDataOldData, setvarCustomDialogDataOldData] = useState({});
  const [sectionComponentDataAware, setSectionComponentDataAware] = useState();
  
  const [varCustomDialogData,setVarCustomDialogData] = useState([])
  const [varCustomDialogTitle,setVarCustomDialogTitle] = useState('')
  const [varCutomDialogApi,setvarCutomDialogApi] = useState('')
  const [defaultTableSelectedLocation, setDefaultTableSelectedLocation] = useState("");
  const [defaultTableSelectedSupplier, setDefaultTableSelectedSupplier] = useState("");
  const [defaultTableSelectedDataAwareData, setDefaultTableSelectedDataAwareData] = useState({});
  const [defaultTableCSVFile, setDefaultTableCSVFile] = useState([]);
  const [debugSectionAPIData, setDebugSectionAPIData] = useState([]);
  const [openDebugSection, setOpenDebugSection] = useState(true);
  const [clearWithholdingTax, setClearWithholdingTax] = useState({initial: false, update: false});
  const [conversionNamesMapping, setConversionNamesMapping] = useState({});
  const [submitPayloadLoading, setSubmitPayloadLoading] = useState(false);
  const [shippingId, setShippingId] = useState();
  const [bulkData, setBulkData] = useState();
  const [infoAlert, setInfoAlert] = useState([]);
  const [progressState, setProgressState] = useState({
  open: false,
  loading: false,
  message: "",
  module: "",
  formType: "",
  action: "",
  currentPrimaryKeyValue: "",
  type: "",
  status: "",
  operationId: "",
  totalCount: 0,
  processedCount: 0,
  remainingCount: 0,
  successCount: 0,
  failureCount: 0
});
const [progressOperations, setProgressOperations] = useState({});
const activeProgressOperationIdRef = useRef("");

const registerBulkOperation = useCallback((operationId, metadata = {}) => {
  if (!operationId) return;
  activeProgressOperationIdRef.current = operationId;
  setProgressOperations(previous => ({
    ...previous,
    [operationId]: { operationId, ...metadata, open: false, loading: true }
  }));
}, []);

const sseErrorShownRef = React.useRef({});
const previousNotificationTokenRef = React.useRef(token);

useEffect(() => subscribePersistentAlerts(alert => {
  const scopedAlert = scopeAlertToRoute(alert, mainRouteRef.current);
  setInfoAlert(previous => (
    previous.some(existingAlert => existingAlert.id === scopedAlert.id)
      ? previous
      : [scopedAlert, ...previous]
  ));
}), []);

useEffect(() => {
  if (previousNotificationTokenRef.current && !token) {
    setInfoAlert([]);
    sseErrorShownRef.current = {};
  }

  previousNotificationTokenRef.current = token;
}, [token]);

const createAuthenticatedEventSource = url => {
  const accessToken = token || getAccessToken();

  if (!url || !accessToken) {
    return null;
  }

  return new EventSourcePolyfill(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    heartbeatTimeout: 120000
  });
};

const notifySSEConnectionError = (key, message) => {
  if (sseErrorShownRef.current[key]) {
    return;
  }

  sseErrorShownRef.current[key] = true;
  const persistentId = `persistent-alert-error-sse-connection-${String(key).toLowerCase()}`;
  CustomAlert("error", message, {
    source: "sse",
    domain: "connection",
    action: key,
    persistentId,
    toastId: persistentId
  });
};

const clearSSEConnectionError = key => {
  sseErrorShownRef.current[key] = false;
  const persistentId = `persistent-alert-error-sse-connection-${String(key).toLowerCase()}`;
  setInfoAlert(previous => previous.filter(alert => alert.id !== persistentId));
};

const dismissInfoAlert = useCallback(id => {
  setInfoAlert(previous => {
    const dismissedAlert = previous.find(alert => alert.id === id);

    if (dismissedAlert?.source === "sse" && dismissedAlert?.domain === "connection") {
      sseErrorShownRef.current[dismissedAlert.action] = false;
    }

    return previous.filter(alert => alert.id !== id);
  });
}, []);

  useEffect(() => {
    if (!open) {
      setEditApi(null);
      setModalEditData({});
    }
  }, [open]);

  const parseURL = urlString => {
    try {
      // Find the index of "?" in the URL
      const queryIndex = urlString.indexOf("&");

      // Extract the pathname
      const pathname = queryIndex !== -1 ? urlString.slice(0, queryIndex) : urlString;

      // Extract the search  query
      const searchQuery = queryIndex !== -1 ? urlString.slice(queryIndex) : "";

      // Return the results
      return { pathname, searchQuery };
    } catch (error) {
      // Handle invalid URLs
      console.error("Invalid URL:", urlString);
      return null;
    }
  };

//   // LISTENER-ALERT: connects to REACT_ALERT_API and fires toast notifications
//   useEffect(() => {
//     const alertUrl = window.__ENV__?.REACT_ALERT_API || process.env.REACT_ALERT_API;
//     console.log("[SSE-ALERT] URL:", alertUrl);

//     if (!alertUrl) return;

//     const es = createAuthenticatedEventSource(alertUrl);
//     if (!es) return;

//     es.onopen = () => {
//         console.log("[SSE-ALERT] Connection opened");
//         clearSSEConnectionError("ALERT");
//       };

//       es.onerror = err => {
//         console.error("[SSE-ALERT] Connection error:", err);
//         notifySSEConnectionError("ALERT", "Cannot connect to Alerts SSE");
//       };

//     const get3PTPayload = parsed => {
//       if (!parsed || typeof parsed !== "object") return null;

//       return (
//         parsed?.data?.msg ||
//         parsed?.data?.data ||
//         parsed?.msg ||
//         parsed?.data ||
//         parsed
//       );
//     };

//     const handler = e => {
//       console.log("[SSE-ALERT] Raw event:", e.type, e.data);

//       try {
//         const parsed = JSON.parse(e.data);
//         const payload = get3PTPayload(parsed);

//         const msg = payload?.metadata?.msg;
//         const type = payload?.metadata?.status?.toUpperCase();

//         console.log("[SSE-ALERT] payload:", payload);
//         console.log("[SSE-ALERT] msg:", msg, "type:", type);

//         if (!msg) return;

//         if (type === "ERROR") toast.error(msg);
//         else if (type === "WARNING") toast.warning(msg);
//         else if (type === "INFORMATION" || type === "INFO") toast.info(msg);
//         else if (type === "SUCCESS" || type === "OK") toast.success(msg);
//         else toast(msg);
//       } catch (err) {
//         console.error("[SSE-ALERT] Parse error:", err.message, e.data);
//       }
//     };

//     es.onmessage = handler;

//     try {
//       const url = new URL(alertUrl);
//       const eventNames = url.searchParams.get("event")?.split(",") || [];

//       console.log("[SSE-ALERT] Listening for events:", eventNames);

//       eventNames.forEach(evt => {
//         if (evt.trim()) {
//           es.addEventListener(evt.trim(), handler);
//         }
//       });
//     } catch (_) {
//       // ignore invalid URL
//     }

//     return () => es.close();
// }, [token]);

//   // LISTENER-INFORMATION: connects to REACT_INFORMATION_API and stores alert for form Info section
//   useEffect(() => {
//     const infoUrl = window.__ENV__?.REACT_INFORMATION_API || process.env.REACT_INFORMATION_API;
//     console.log('[SSE-INFO] URL:', infoUrl);
//     if (!infoUrl) return;
//     const es = createAuthenticatedEventSource(infoUrl);
//       if (!es) return;
      
//     es.onopen = () => {
//         console.log("[SSE-INFO] Connection opened");
//         clearSSEConnectionError("INFO");
//       };

//       es.onerror = err => {
//         console.error("[SSE-INFO] Connection error:", err);
//         notifySSEConnectionError("INFO", "Cannot connect to Info SSE");
//       };
//     const handler = (e) => {
//       console.log('[SSE-INFO] Raw event:', e.type, e.data);
//       try {
//         const parsed = JSON.parse(e.data);
//         const msg = parsed?.metadata?.msg;
//         if (!msg) return;
//         const type = parsed?.data?.type?.toUpperCase();
//         setInfoAlert(prev => [{ id: Date.now(), type, msg }, ...prev]);
//         if (type === 'ERROR') toast.error(msg);
//         else if (type === 'WARNING') toast.warning(msg);
//         else if (type === 'SUCCESS') toast.success(msg);
//         else toast.info(msg);
//       } catch (err) { console.error('[SSE-INFO] Parse error:', err.message, e.data); }
//     };
//     es.onmessage = handler;
//     try {
//       const url = new URL(infoUrl);
//       const eventNames = url.searchParams.get('event')?.split(',') || [];
//       console.log('[SSE-INFO] Listening for events:', eventNames);
//       eventNames.forEach(evt => es.addEventListener(evt.trim(), handler));
//     } catch (_) { /* ignore invalid URL */ }
//     return () => es.close();
// }, [token]);

//   // LISTENER-NOTIFICATION: connects to REACT_NOTIFICATION_API and fires toast for Transaction events
//     useEffect(() => {
//       const notifUrl = window.__ENV__?.REACT_NOTIFICATION_API || process.env.REACT_NOTIFICATION_API;
//       console.log('[SSE-NOTIF] URL:', notifUrl);
//       if (!notifUrl) return;
//       const es = createAuthenticatedEventSource(notifUrl);
//         if (!es) return;
//       es.onopen = () => {
//         console.log("[SSE-NOTIFICATION] Connection opened");
//         clearSSEConnectionError("NOTIFICATION");
//       };

//       es.onerror = err => {
//         console.error("[SSE-NOTIFICATION] Connection error:", err);
//         notifySSEConnectionError("NOTIFICATION", "Cannot connect to Notification SSE");
//       };
//       const handler = (e) => {
//         console.log('[SSE-NOTIF] Raw event:', e.type, e.data);
//         try {
//           const parsed = JSON.parse(e.data);
//           const msg = parsed?.metadata?.msg;
//           const type = parsed?.data?.type?.toUpperCase();
//           console.log('[SSE-NOTIF] msg:', msg, 'type:', type);
//           if (!msg) return;
//           if (type === 'ERROR') toast.error(msg);
//           else if (type === 'WARNING') toast.warning(msg);
//           else if (type === 'INFO') toast.info(msg);
//           else toast.success(msg);
//         } catch (err) { console.error('[SSE-NOTIF] Parse error:', err.message, e.data); }
//       };
//       es.onmessage = handler;
//       try {
//         const url = new URL(notifUrl);
//         const eventNames = url.searchParams.get('event')?.split(',') || [];
//         console.log('[SSE-NOTIF] Listening for events:', eventNames);
//         eventNames.forEach(evt => es.addEventListener(evt.trim(), handler));
//       } catch (_) { /* ignore invalid URL */ }
//       return () => es.close();
// }, [token]);

//     // LISTENER-PROGRESS: connects to REACT_PROGRESS_API and listens for Progress events
//   // LISTENER-PROGRESS: connects to REACT_PROGRESS_API and displays backend progress
// useEffect(() => {
//   const progressUrl =
//     window.__ENV__?.REACT_PROGRESS_API || process.env.REACT_PROGRESS_API;

//   console.log("[SSE-PROGRESS] URL:", progressUrl);

//   if (!progressUrl) return;

//   const es = createAuthenticatedEventSource(progressUrl);
//     if (!es) return;

//   es.onopen = () => {
//       console.log("[SSE-PROGRESS] Connection opened");
//       clearSSEConnectionError("PROGRESS");
//     };

//   es.onerror = err => {
//     console.error("[SSE-PROGRESS] Connection error:", err);

//     setProgressState({
//       open: true,
//       loading: false,
//       message: "Cannot connect to Progress SSE",
//       module: "PROGRESS",
//       type: "ERROR",
//       status: "ERROR"
//     });
//   };

//   const handler = e => {
//     console.log("[SSE-PROGRESS] Raw event:", e.type, e.data);

//     try {
//       const parsed = JSON.parse(e.data);

//       const progressPayload =
//         parsed?.data?.metadata
//           ? parsed.data
//           : parsed?.data?.data?.metadata
//             ? parsed.data.data
//             : parsed;

//       const metadata = progressPayload?.metadata || {};
//       const progressData = progressPayload?.data || {};

//       const message = metadata?.msg || "";
//       const status = metadata?.status || parsed?.status || "";
//       const type = progressData?.type || "";
//       const module = progressData?.module || "";

//       console.log("[SSE-PROGRESS] Parsed:", {
//         message,
//         status,
//         type,
//         module
//       });

//       const normalizedStatus = String(status).toUpperCase();
//       const normalizedType = String(type).toUpperCase();

//       if (normalizedType === "START" || normalizedType === "BODY") {
//         setProgressState({
//           open: true,
//           loading: normalizedStatus === "OK",
//           message,
//           module,
//           type: normalizedType,
//           status: normalizedStatus
//         });

//         return;
//       }

//       if (normalizedType === "END") {
//         setProgressState({
//           open: true,
//           loading: false,
//           message,
//           module,
//           type: normalizedType,
//           status: normalizedStatus
//         });

//         return;
//       }

//       if (normalizedStatus !== "OK") {
//         setProgressState({
//           open: true,
//           loading: false,
//           message,
//           module,
//           type: normalizedType,
//           status: normalizedStatus
//         });
//       }
//     } catch (err) {
//       console.error("[SSE-PROGRESS] Parse error:", err.message, e.data);
//     }
//   };

//   es.onmessage = handler;

//   try {
//     const url = new URL(progressUrl);
//     const eventNames = url.searchParams.get("event")?.split(",") || [];

//     console.log("[SSE-PROGRESS] Listening for events:", eventNames);

//     eventNames.forEach(evt => {
//       if (evt.trim()) {
//         es.addEventListener(evt.trim(), handler);
//       }
//     });
//   } catch (_) {
//     // ignore invalid URL
//   }

//   return () => es.close();
// }, [token]);

//   // LISTENER-EVENT: connects to REACT_EVENT_API and fires toast for 3PT_Event events
//   useEffect(() => {
//     const eventUrl = window.__ENV__?.REACT_EVENT_API || process.env.REACT_EVENT_API;
//     console.log('[SSE-EVENT] URL:', eventUrl);
//     if (!eventUrl) return;
//     const es = createAuthenticatedEventSource(eventUrl);
//         if (!es) return;
//     es.onopen = () => {
//         console.log("[SSE-EVENT] Connection opened");
//         clearSSEConnectionError("EVENT");
//       };

//       es.onerror = err => {
//         console.error("[SSE-EVENT] Connection error:", err);
//         notifySSEConnectionError("EVENT", "Cannot connect to Event SSE");
//       };
//     const handler = (e) => {
//       console.log('[SSE-EVENT] Raw event:', e.type, e.data);
//       try {
//         const parsed = JSON.parse(e.data);
//         const msg = parsed?.metadata?.msg;
//         const type = parsed?.data?.type?.toUpperCase();
//         console.log('[SSE-EVENT] msg:', msg, 'type:', type);
//         if (!msg) return;
//         if (type === 'ERROR') toast.error(msg);
//         else if (type === 'WARNING') toast.warning(msg);
//         else if (type === 'INFO') toast.info(msg);
//         else toast.success(msg);
//       } catch (err) { console.error('[SSE-EVENT] Parse error:', err.message, e.data); }
//     };
//     es.onmessage = handler;
//     try {
//       const url = new URL(eventUrl);
//       const eventNames = url.searchParams.get('event')?.split(',') || [];
//       console.log('[SSE-EVENT] Listening for events:', eventNames);
//       eventNames.forEach(evt => es.addEventListener(evt.trim(), handler));
//     } catch (_) { /* ignore invalid URL */ }
//     return () => es.close();
// }, [token]);

// LISTENER-SSE: connects to one REACT_SSE_API endpoint and routes by event type
useEffect(() => {

  const sseUrl = window.__ENV__?.REACT_SSE_API || process.env.REACT_SSE_API;

  console.log("[SSE] URL:", sseUrl);

  if (!sseUrl || !token) return;

  const es = createAuthenticatedEventSource(sseUrl);
  if (!es) return;

  es.onopen = () => {
    console.log("[SSE] Connection opened");
    clearSSEConnectionError("SSE");
  };

  es.onerror = err => {
    console.error("[SSE] Connection error:", err);
    notifySSEConnectionError("SSE", "Cannot connect to SSE");
  };

  const get3PTPayload = parsed => {
  if (!parsed || typeof parsed !== "object") return null;

  return (
    parsed?.data?.metadata
      ? parsed.data
      : parsed?.data?.msg?.metadata
      ? parsed.data.msg
      : parsed?.data?.data?.metadata
      ? parsed.data.data
      : parsed?.msg?.metadata
      ? parsed.msg
      : parsed?.metadata
      ? parsed
      : null
  );
};
  const getProgressPayload = parsed => {
    if (!parsed || typeof parsed !== "object") return null;

    return parsed?.data?.metadata
      ? parsed.data
      : parsed?.data?.data?.metadata
      ? parsed.data.data
      : parsed;
  };

  const handle3PTMessage = parsed => {
    const payload = get3PTPayload(parsed);

    const msg = payload?.metadata?.msg;
    const type = payload?.metadata?.status?.toUpperCase();

    console.log("[SSE-ALERT] payload:", payload);
    console.log("[SSE-ALERT] msg:", msg, "type:", type);

    const requestID =
      payload?.data?.requestID ||
      payload?.data?.data?.requestID ||
      parsed?.data?.data?.requestID;

    if (requestID) {
      window.dispatchEvent(
        new CustomEvent("BITS_3PT_MESSAGE_SIGNAL", {
          detail: {
            requestID,
            payload
          }
        })
      );
    }

    if (!msg) return;

    CustomAlert(type, msg, {
      source: "sse",
      domain: "3pt-message",
      action: "notification",
      correlationId: requestID
    });

  };

  const handleSystem = parsed => {
    const msg = parsed?.metadata?.msg;
    if (!msg) return;

    const type = parsed?.data?.type?.toUpperCase();

    CustomAlert(type, msg, {
      source: "sse",
      domain: "system",
      action: "notification"
    });
  };

  const handleTransaction = parsed => {
    const msg = parsed?.metadata?.msg;
    const type = parsed?.data?.type?.toUpperCase();

    console.log("[SSE-NOTIF] msg:", msg, "type:", type);

    if (!msg) return;

    CustomAlert(type, msg, {
      source: "sse",
      domain: "transaction",
      action: "notification"
    });
  };

  const handleProgress = parsed => {
    const progressPayload = getProgressPayload(parsed);

    const metadata = progressPayload?.metadata || {};
    const progressData = progressPayload?.data || {};

    const message = String(metadata?.msg || "").replace(/\\n/g, "\n");
    const status = metadata?.status || parsed?.status || "";
    const type = progressData?.type || "";
    const module = progressData?.module || "";
    const operationId = progressData?.operationId || "";

    const normalizedStatus = String(status).toUpperCase();
    const normalizedType = String(type).toUpperCase();

    const nextProgressState = {
      open: normalizedType !== "CLOSE",
      loading: normalizedType === "START" || normalizedType === "BODY",
      message,
      module,
      formType: progressData?.formType || "",
      action: progressData?.action || "",
      currentPrimaryKeyValue: progressData?.currentPrimaryKeyValue || "",
      type: normalizedType,
      status: normalizedStatus,
      operationId,
      totalCount: Number(progressData?.totalCount || 0),
      processedCount: Number(progressData?.processedCount || 0),
      remainingCount: Number(progressData?.remainingCount || 0),
      successCount: Number(progressData?.successCount || 0),
      failureCount: Number(progressData?.failureCount || 0)
    };

    console.log("[SSE-PROGRESS] Parsed:", {
      message,
      status,
      type,
      module,
      operationId
    });

    if (operationId) {
      setProgressOperations(previous => ({ ...previous, [operationId]: nextProgressState }));
      if (!activeProgressOperationIdRef.current) activeProgressOperationIdRef.current = operationId;
      if (activeProgressOperationIdRef.current !== operationId) return;
    } else if (activeProgressOperationIdRef.current) {
      // Keep unrelated legacy/OmniChannel progress from overwriting an active,
      // correlated Bulk operation. Its event is still delivered; it simply owns
      // no slot in the Bulk operation map.
      return;
    }

    if (normalizedType === "CLOSE") {
      setProgressState(nextProgressState);
      if (operationId === activeProgressOperationIdRef.current) {
        activeProgressOperationIdRef.current = "";
      }

      return;
    }

    if (normalizedType === "START" || normalizedType === "BODY") {
      setProgressState(nextProgressState);

      return;
    }

    if (normalizedType === "END") {
      setProgressState(nextProgressState);

      return;
    }

    if (normalizedStatus !== "OK") {
      setProgressState({ ...nextProgressState, loading: false });

      if (message) {
        CustomAlert(normalizedStatus || "ERROR", message, {
          source: "sse",
          domain: "progress",
          action: normalizedType || "notification"
        });
      }
    }
  };

  const handler = e => {
    console.log("[SSE] Raw event:", e.type, e.data);

    try {
      const parsed = JSON.parse(e.data);
      const eventType = e.type || parsed?.event || parsed?.event_type;

      if (eventType === "3PT_Message") {
        handle3PTMessage(parsed);
      } else if (eventType === "System") {
        handleSystem(parsed);
      } else if (eventType === "Transaction") {
        handleTransaction(parsed);
      } else if (eventType === "Progress") {
        handleProgress(parsed);
      } else if (eventType === "SESSION_REVOKED") {
        clearAuthentication(parsed?.reason || "SESSION_REPLACED");
      }
    } catch (err) {
      console.error("[SSE] Parse error:", err.message, e.data);
    }
  };

  es.onmessage = handler;

  try {
    const url = new URL(sseUrl);
    const eventNames = url.searchParams.get("event")?.split(",") || [];

    console.log("[SSE] Listening for events:", eventNames);

    eventNames.forEach(evt => {
      if (evt.trim()) {
        es.addEventListener(evt.trim(), handler);
      }
    });
    es.addEventListener("SESSION_REVOKED", handler);
  } catch (_) {
    // ignore invalid URL
  }

  return () => es.close();
}, [token]);

  const NON_FORM_ROUTES = [
    "/login",
    "/testapi",
    "/csv",
    "/import",
    "/websocket-demo"
  ];

  const isPublicOrNonFormRoute = path => {
    const safePath = String(path || "").toLowerCase();

    return (
      NON_FORM_ROUTES.some(r => safePath.startsWith(r.toLowerCase())) ||
      safePath.includes("resetpassword")
    );
  };

  const handleFormRequestError = useCallback(error => {
    if (error?.response?.status === 401) {
      if (mainRouteRef.current !== "/login") {
        navigate("/login");
      }
      return;
    }

    if (error?.response?.status === 400) {
      setIsAlertPopup({ open: true, msg: error?.response?.data?.metadata?.msg });
      return;
    }

    console.error("[GlobalData.js] Form metadata request failed:", error);
  }, [navigate]);

  const fetchFormaData1 = useCallback((requestedRoute = mainRouteRef.current) => {
    if (isPublicOrNonFormRoute(requestedRoute)) {
      formRequestManagerRef.current.cancel("main");
      console.warn("[GlobalData.js] Skipped form metadata fetch for route:", requestedRoute);
      return Promise.resolve({ applied: false, canceled: true });
    }

    const parsedUrl = parseURL(`${baseURL}${requestedRoute}`);
    const requestUrl = parsedUrl.searchQuery.startsWith("&doc")
      ? parsedUrl.pathname + parsedUrl.searchQuery
      : parsedUrl.pathname;

    setFormData("");

    return formRequestManagerRef.current.run({
      scope: "main",
      route: requestedRoute,
      getCurrentRoute: () => mainRouteRef.current,
      setLoading: setisPageLoading,
      request: ({ signal }) => axios.get(requestUrl, {
        signal,
        headers: { Authorization: `Bearer ${token}` }
      }),
      apply: result => {
        const nextFormData = result?.data?.data ? result.data.data : result?.data;
        setFormData(nextFormData);
        setmainFormData(nextFormData);
        setOverLaySplitOldData(nextFormData);
        if (!isDialogDrawerOpenRef.current) {
          setvarCustomDialogDataOldData(nextFormData);
        }
      },
      onError: handleFormRequestError,
      isCanceled: error => axios.isCancel(error) || error?.code === "ERR_CANCELED"
    });
  }, [token, handleFormRequestError]);

  const fetchOverlayFormData = useCallback(requestedRoute => {
    if (!requestedRoute) {
      return Promise.resolve({ applied: false, canceled: true });
    }

    const parentRoute = mainRouteRef.current;
    overlayRouteRef.current = requestedRoute;
    setFormData("");

    return formRequestManagerRef.current.run({
      scope: "overlay",
      route: requestedRoute,
      getCurrentRoute: () => mainRouteRef.current,
      isRouteCurrent: () => (
        mainRouteRef.current === parentRoute &&
        overlayRouteRef.current === requestedRoute
      ),
      setLoading: setisoverLayDataLoading,
      request: ({ signal }) => axios.get(serverAddress + requestedRoute, {
        signal,
        headers: { Authorization: `Bearer ${token}` }
      }),
      apply: result => {
        const nextFormData = result?.data?.data ? result.data.data : result?.data;
        // Overlay rendering temporarily uses formData, while mainFormData stays
        // bound to the current React Router route.
        setFormData(nextFormData);
        if (!isDialogDrawerOpenRef.current) {
          setvarCustomDialogDataOldData(nextFormData);
        }
      },
      onError: handleFormRequestError,
      isCanceled: error => axios.isCancel(error) || error?.code === "ERR_CANCELED"
    });
  }, [token, handleFormRequestError]);

  useEffect(() => {
    if (previousMainRouteRef.current !== mainRoute) {
      overlayRouteRef.current = "";
      formRequestManagerRef.current.cancel("overlay");
      setOverLaySplit(false);
      setInfoAlert(previous => retainAlertsForRoute(previous, mainRoute));
      previousMainRouteRef.current = mainRoute;
    }
  }, [mainRoute]);

  useEffect(() => {
    const isNonFormRoute = isPublicOrNonFormRoute(mainRoute);

    if (token && !isNonFormRoute) {
      fetchFormaData1(mainRoute);
    } else {
      formRequestManagerRef.current.cancel("main");
    }
  // location.key changes even when navigation targets the same URL. This is
  // required by Save and New so the Add definition is fetched and its defaults
  // are reapplied instead of reusing the completed Add form instance.
  }, [mainRoute, formname.key, token, fetchFormaData1]);

  useEffect(() => {
    if (token && overlaySplit && overLayDataFetchApi) {
      fetchOverlayFormData(overLayDataFetchApi);
    } else {
      overlayRouteRef.current = "";
      formRequestManagerRef.current.cancel("overlay");
    }
  }, [token, overlaySplit, overLayDataFetchApi, fetchOverlayFormData]);

  useEffect(() => () => {
    formRequestManagerRef.current.cancelAll();
  }, []);

  useEffect(() => {
    if (editApi && open) {
      // console.log(editApi,modalPrimaryKey, "editApi");
      if(!editApi?.includes("undefined")){
        axios
          .get(`${serverAddress}${editApi}`, {
            headers: {
              Authorization: `Bearer ${token}`
              // Other headers if needed
            }
          })
          .then(response => setModalEditData(response.data.data.mainrecord))
          .catch(err => console.log(err));
      }
    }
  }, [editApi, open]);

  function parseJsonString(jsonString) {
    try {
      const jsonObject = JSON.parse(jsonString);
      return jsonObject;
    } catch (error) {
      console.error("Failed to parse JSON string:", error);
      return null;
    }
  }
  useEffect(() => {
    const userData = localStorage.getItem("userData");
    const storedToken = getAccessToken();

    // Allow some routes to be accessed without authentication
    const currentPath = formname.pathname;
    // Treat /login and any path that CONTAINS 'resetpassword' as public
    const isPublicRoute =
      currentPath === "/login" || currentPath.includes("resetpassword") || currentPath === "/websocket-demo";

    if (storedToken) {
      setToken(storedToken);
      // /record/get/sys_template/default

      axios
        .get(`${serverAddress}/record/get/sys_template/default`, {
          headers: {
            Authorization: `Bearer ${storedToken}`
            // Other headers if needed
          }
        })
        .then(response => {
          setsideBarStyle(parseJsonString(response.data.data.mainrecord.sTemplateSections));
        })
        .catch(err => {
          localStorage.clear();
          navigate("/login");
        });
    } else if (!isPublicRoute) {
      refreshSession().catch(() => {
        clearAuthentication("SESSION_REVOKED");
        navigate("/login");
      });
    }

    if (userData) {
      setUserData(JSON.parse(userData));
    } else if (!isPublicRoute) {
      navigate("/login");
    }

    const activeMenu = localStorage.getItem("activeSideItems");
    setsideBarActive(activeMenu);
  }, []);

  // https://www.youtube.com/feed/trending?bp=6gQJRkVleHBsb3Jl

  function LogoutOnError() {
    clearAuthentication("SESSION_REVOKED");
    navigate("/login");
  }

  function setsideBarActiveBtn(id) {
    localStorage.setItem("activeSideItems", id);
    getsideBarActiveBtn();
  }
  function getsideBarActiveBtn() {
    const activeMenu = localStorage.getItem("activeSideItems");
    setsideBarActive(activeMenu);
  }
  const [theamStyle, setTheamStyle] = React.useState({});

  function parseJsonString3(jsonString) {
    try {
      const jsonObject = JSON.parse(jsonString);
      return jsonObject;
    } catch (error) {
      console.error("Failed to parse JSON string:", error);
      return null;
    }
  }

  useEffect(() => {
    if(token){
      axios
      .get(`${serverAddress}/record/get/sys_template/default`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setsideBarStyle(parseJsonString(response.data.data.mainrecord.sTemplateSections));
        const theme = createTheme(parseJsonString3(response.data.data.mainrecord.sTheme));
        setTheamStyle(theme);
      })
      .catch(err => {
        localStorage.clear();
        navigate("/login");
      });
    }
  }, [token]);

  useEffect(() => {
    const updateToken = event => setToken(event.detail || null);
    const logout = event => {
      setToken(null);
      setUserData(undefined);
      setsideBarStyle("");
      const reason = event.detail;
      if (reason === "SESSION_REPLACED") {
        CustomAlert("error", "Your account was signed in on another device.", {
          domain: "authentication",
          action: "session-replaced"
        });
      }
      if (mainRouteRef.current !== "/login") navigate("/login", { replace: true });
    };
    window.addEventListener("bits-auth-token", updateToken);
    window.addEventListener("bits-auth-logout", logout);
    return () => {
      window.removeEventListener("bits-auth-token", updateToken);
      window.removeEventListener("bits-auth-logout", logout);
    };
  }, [navigate]);

  return (
    <Contaxt.Provider
      value={{
        editApi,
        globalvariables,
        formData,
        setFormData,
        setglobalvariables,
        setEditApi,
        fetchDataHandleDataGrid,
        setFetchDataHandleDataGrid,
        reportPrintUpdate,
        setReportPrintUpdate,
        token,
        setToken,
        userData,
        setUserData,
        modalActionTypeAndID,
        setModalActionTypeAndID,
        isoverLayDataLoading,
        setisoverLayDataLoading,
        LogoutOnError,
        handleClickOpen,
        setHandleClickOpen,
        modalEditData,
        setModalEditData,
        defaultTableSummaryData,
        setDefaultTableSummaryData,
        textValue,
        isAlertPopup,
        setIsAlertPopup,
        defaultTableSummaryFeild,
        setdefaultTableSummaryFeild,
        setTextValue,
        globalFormData,
        setGlobalFormData,
        theamStyle,
        modalPrimaryKey,
        isDialogDrawerOpen,
        setDialogDrawerOpen,
        setModalPrimaryKry,
        setsideBarStyle,varCutomDialogApi,setvarCutomDialogApi,
        openModalData,
        freeFromtableRowDataStore,
        setFreeFromTableRowDataStore,
        setOpenModalData,
        nestedDialog,
        setNestedDialog,
        open,
        fetchFormaData1,
        isOpenModalChildData,
        setIsOpenModalChildData,
        setOpen,
        setOverLaySplit,
        overlaySplit,
        freeFormInitState,
        overLayDataFetchApi,
        setOverLayDataFetchApi,
        setFreeFormInitState,
        setmultiDocumentSelectDataForTable,
        multiDocumentSelectDataForTable,
        mainFormData,
        setmainFormData,
        sideBarStyle,
        overlaySplitOldData,
        setOverLaySplitOldData,
        sideBarActive,
        isPageLoading,
        setisPageLoading,
        openDocumentSelect,
        setOpenDocumentSelect,
        setsideBarActive,setVarCustomDialogTitle,varCustomDialogTitle,
        openModalDataActive,
        setopenModalDataActive,
        setsideBarActiveBtn,
        openModalChildData,varCustomDialogData,setVarCustomDialogData,
        setOpenModalChildData,
        multiDocumentSelectData,
        setMultiDocumentSelectData,
        autoCompleteAPICheck, setAutoCompleteAPICheck,
        autoCompleteData, setAutoCompleteData,
        globalReloadTriggred, setGlobalReloadTriggered,
        freeFormToDefault, setFreeFormToDefault,
        defaultTableSelectedLocation, setDefaultTableSelectedLocation,
        defaultTableSelectedSupplier, setDefaultTableSelectedSupplier,
        debugSectionAPIData, setDebugSectionAPIData, 
        openDebugSection, setOpenDebugSection,
        clearWithholdingTax, setClearWithholdingTax,
        defaultTableSelectedDataAwareData, setDefaultTableSelectedDataAwareData,
        globalDefaultAutoValueData, setGlobalDefaultAutoValueData,
        defaultTableCSVFile, setDefaultTableCSVFile,
        freeFormDataSubmit, setFreeFormDataSubmit,
        sectionComponentDataAware, setSectionComponentDataAware,
        conversionNamesMapping, setConversionNamesMapping,
        submitPayloadLoading, setSubmitPayloadLoading,
        shippingId, setShippingId,
        globalFreeFormAutoValueData, setGlobalFreeFormAutoValueData,
        dataGridOptions, setDataGridOptions,
        bulkData, setBulkData,
        infoAlert, setInfoAlert, dismissInfoAlert,
        registerBulkOperation,
        progressOperations
      }}
    >
      <ThemeProvider theme={theamStyle}>{children}</ThemeProvider>
      {progressState.open && (
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 999999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.25)"
        }}
      >
        <Paper
          elevation={6}
          sx={{
            width: 420,
            p: 3,
            borderRadius: 2,
            textAlign: "center"
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              mb: 2,
              fontWeight: 600,
              whiteSpace: "pre-line"
            }}
          >
            {progressState.message}
          </Typography>

          {(progressState.module || progressState.action) && (
            <Typography variant="body2" sx={{ mb: 1 }}>
              {[progressState.module, progressState.action].filter(Boolean).join(" · ")}
              {progressState.currentPrimaryKeyValue
                ? ` · ${progressState.currentPrimaryKeyValue}`
                : ""}
            </Typography>
          )}

          {progressState.totalCount > 0 && (
            <Typography variant="body2" sx={{ mb: 1 }}>
              {progressState.processedCount} / {progressState.totalCount} processed · {progressState.remainingCount} remaining · {progressState.successCount} successful · {progressState.failureCount} failed
            </Typography>
          )}

          {progressState.loading && (
            <LinearProgress
              variant={progressState.totalCount > 0 ? "determinate" : "indeterminate"}
              value={progressState.totalCount > 0
                ? Math.min(100, (progressState.processedCount / progressState.totalCount) * 100)
                : undefined}
              sx={{ mb: 2 }}
            />
          )}

          {!progressState.loading && (
            <Button
              variant="contained"
              onClick={() =>
                {
                  activeProgressOperationIdRef.current = "";
                  setProgressState(prev => ({
                    ...prev,
                    open: false
                  }));
                }
              }
            >
              Close
            </Button>
          )}
        </Paper>
      </Box>
    )}

    </Contaxt.Provider>
  );
}
export const Global_Data = () => useContext(Contaxt);

export default memo(GlobalData);

